import { memo } from 'react';

import DynamicReactComponentStrip from './DynamicReactComponentStrip';

const ToolCallsUI = memo(({ tool_calls, currentToolResponseForReference }) => {
  return (
    <>
      {tool_calls.map((tool_call) => {
        if (tool_call.function?.name !== 'render_dynamic_react_component') {
          return null;
        }
        let rawResponseParsed = {};
        try {
          rawResponseParsed = JSON.parse(tool_call.function?.arguments || '{}');
        } catch (err) {
          return null;
        }
        const contentParsed =
          rawResponseParsed?.tool_response || rawResponseParsed;

        const componentString = contentParsed.component_string || '() => {}';
        const title = contentParsed.title || 'React Component';

        if (contentParsed.error) {
          return null;
        }
        return (
          <DynamicReactComponentStrip
            componentString={componentString}
            stripTitle={title}
            modalTitle={title}
            toolReferences={currentToolResponseForReference}
          />
        );
      })}
    </>
  );
});

ToolCallsUI.displayName = 'ToolCallsUI';

export default ToolCallsUI;
